/**
 * @generated SignedSource<<770cb550466fe10fef79dd3763ad7500>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizMainContainerHeader_participativeModule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizViewModeSwitch_participativeModule"
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "f421e78e8802921e2ba3d3f62854907c";

module.exports = node;
